import { render, staticRenderFns } from "./SendCVDialog.vue?vue&type=template&id=0022aa80&scoped=true"
import script from "./SendCVDialog.vue?vue&type=script&lang=ts"
export * from "./SendCVDialog.vue?vue&type=script&lang=ts"
import style0 from "./SendCVDialog.vue?vue&type=style&index=0&id=0022aa80&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0022aa80",
  null
  
)

export default component.exports